import React, { useState, useEffect } from 'react';
export default function VotersWhoVotedCount(){

	const [totalVoter, setTotalVoter] = useState(0)
	const [totalVoterWhoVoted, setTotalVoterWhoVoted] = useState(0)
	const [totalWhoDidNotLogOut, setTotalWhoDidNotLogOut] = useState(0)
	const [totalVoters, setTotalVoters] = useState(0)
	
	const count = ()=>{

		fetch(`http://localhost:4000/students/getStudentVotingStatus`, {
		// fetch(`https://gnhs2023ssgelection.herokuapp.com/students/getStudentVotingStatus`, {
		method: 'GET',
		headers: {
			"Content-Type": 'application/json',
			"Authorization": `Bearer ${localStorage.getItem('accessToken')}`}
		})
		.then(res=> res.json())
		.then (data => {
			setTotalVoterWhoVoted(parseInt(data.totalWhoVoted))
			setTotalVoter(parseInt(data.totalVoter))
			setTotalWhoDidNotLogOut(parseInt(data.totalWhoDidNotLogOut))
			setTotalVoters(totalWhoDidNotLogOut+totalVoterWhoVoted)
			console.log(totalVoter)
			console.log(totalVoterWhoVoted)
			
		})
	}

	useEffect(()=>{
		count()
		
	}, [])

	return(
		<>
			
			
			{/*<h5 className="p-1 text-left" id="">Time & Date: <strong>{Date()}</strong></h5>
			<h5 className="p-1 text-left" id="">Total Voters: <strong>{4905}</strong></h5> 
			<h5 className="p-1 text-left" id=""> Done Voting: <strong>{1247}</strong></h5>*/}
			
			<h5 className="p-1 text-left" id=""> Remaining Voters: <strong>{totalVoter-totalVoters}</strong></h5>
			<h5 className="p-1 text-left" id="">Time & Date: <strong>{Date()}</strong></h5>
			<h5 className="p-1 text-left" id="">Total Voters: <strong>{totalVoter}</strong></h5> 
			<h5 className="p-1 text-left" id=""> Done Voting: <strong>{totalVoters}</strong></h5>
			<h5 className="p-1 text-left" id=""> Remaining Voters: <strong>{totalVoter-totalVoters}</strong></h5>
			
		</>
	)

}